import { createRouter, createWebHistory } from 'vue-router'
import Home from "@/pages/home/home.vue";

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
    },
    // 其它路由...
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router

